export default "__VITE_ASSET__CuPAZ_9E__"